export default __webpack_public_path__ + "static/media/spiderman-img-main.2809dcbb.png";